import { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import {
  DeleteCourse,
  EditCourses,
  GetCategories,
  GetCourses,
  ManageCourse,
} from "./actions";

const Courses = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [mediaTypes, setMediaTypes] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);

  const Schema = Yup.object().shape({
    name: Yup.string().trim().required("required"),
    description: Yup.string().trim().required("required"),
    objectives: Yup.string().trim().required("required"),
    duration: Yup.string().trim().required("required"),
    price: Yup.string().trim().required("required"),
    course_category_id: Yup.string().trim().required("required"),
    // demo_video: Yup.string().trim().required("required"), // not required
    image: Yup.string().trim().required("required"),
  });

  const GetData = ({ tableName = null, type = null }) => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetCourses({
        page: page + 1,
        rowsPerPage,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
            setTotalData(data?.count);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      }),
    );
    dispatch(
      GetCategories({
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setMediaTypes(data?.data);
            if (array.length == 0) {
              setarray([
                {
                  failed: "id",
                  type: inputType.text,
                  title: "id",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { display: "none" },
                },
                {
                  failed: "image",
                  type: inputType.image,
                  title: "Image",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                  fileTypes: ["JPG", "PNG", "JPEG", "WEBP"],
                  multiple: false,
                  label: "Drag & Drop Image here or click to select image",
                  fileOrFiles: "File",
                },
                {
                  failed: "demo_video", // not required
                  type: inputType.image,
                  title: "Video",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                  fileTypes: ["MP4", "AAC", "FLAC", "OGG"],
                  multiple: false,
                  label: "Drag & Drop Video here or click to select video",
                  fileOrFiles: "File",
                },
                {
                  failed: "name",
                  type: inputType.text,
                  title: "Name",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "zoom_link",
                  type: inputType.text,
                  title: "Zoom Link",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "workshop_info",
                  type: inputType.text,
                  title: "Workshop Info",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "description",
                  type: inputType.text,
                  title: "Description",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "objectives",
                  type: inputType.editor,
                  title: "Objectives",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "duration",
                  type: inputType.text,
                  title: "Duration",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "price",
                  type: inputType.text,
                  title: "Price",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "date",
                  type: inputType.date,
                  title: "Date",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "secondary_date",
                  type: inputType.date,
                  title: "Secondary Date",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "course_category_id",
                  type: inputType.dropdown,
                  title: "Course Category",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                  datadropdown: data?.data,
                  faileddropdown: {
                    name: "name",
                    value: "id",
                  },
                },
              ]);
            }
          } else {
            setMediaTypes([]);
          }
        },
      }),
    );
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.image, name: "image" },
    { type: columntype.text, name: "name", limitText: true },
    { type: columntype.text, name: "description", limitText: true },
    { type: columntype.html, name: "objectives", limitText: true },
    { type: columntype.text, name: "duration" },
    { type: columntype.text, name: "price" },
    { type: columntype.text, name: "date" },
    { type: columntype.text, name: "secondary_date" },
    { type: columntype.text, name: "categoryname" },
    { type: columntype.vid, name: "demo_video" }, // not required
    { type: columntype.switch, name: "is_active" },
    { type: columntype.switch, name: "is_featured" },
    { type: columntype.switch, name: "is_workshop" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: true,
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Name",
      withSort: false,
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
      withSort: false,
    },
    {
      id: "objectives",
      numeric: false,
      disablePadding: false,
      label: "Objectives",
      withSort: false,
    },
    {
      id: "duration",
      numeric: false,
      disablePadding: false,
      label: "Duration",
      withSort: false,
    },
    {
      id: "price",
      numeric: false,
      disablePadding: false,
      label: "Price",
      withSort: false,
    },
    {
      id: "date",
      numeric: false,
      disablePadding: false,
      label: "Date",
      withSort: false,
    },
    {
      id: "secondary_date",
      numeric: false,
      disablePadding: false,
      label: "Secondary Date",
      withSort: false,
    },
    {
      id: "categoryname",
      numeric: false,
      disablePadding: false,
      label: "Category",
      withSort: false,
    },
    {
      id: "demo_video", // not required
      numeric: false,
      disablePadding: false,
      label: "Video",
      withSort: true,
    },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Is active",
      withSort: true,
    },
    {
      id: "is_featured",
      numeric: false,
      disablePadding: false,
      label: "Is featured",
      withSort: true,
    },
    {
      id: "is_workshop",
      numeric: false,
      disablePadding: false,
      label: "Is workshop",
      withSort: true,
    },
    (dataPrivileges["20"]?.access_edit == 1 ||
      dataPrivileges["20"]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = [
    dataPrivileges["20"]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete "${row?.name ?? ""}"?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteCourse({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      courseId: [row.id],
                    }),
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges["20"]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditCourses({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
        },
      }),
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };

  const debounceRef = useRef(null);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearch(value);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      if (value === "" || !value) {
        return;
      }

      dispatch(
        GetCourses({
          rowsPerPage,
          page: page + 1,
          search: value, // Use latest value directly
          callback: (data) => {
            if (data) {
              setData(data?.data);
            }
          },
        }),
      );
    }, 1000);
  };

  return (
    <>
      <DynamicTable
        withNavigateToFormAndLinkIs="/course-files"
        handleSearch={handleSearch} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(courseId) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteCourse({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      courseId: courseId,
                    }),
                  ),

                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={dataPrivileges["20"]?.access_write === 1}
        withDeleteItem={dataPrivileges["20"]?.access_delete === 1}
        withEditItem={dataPrivileges["20"]?.access_edit === 1}
        withPagination={true}
        withSearch={true}
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Course"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add new Course"}
          buttonTitle={editMode ? "Edit" : "Add"}
          onSubmit={(valuess) => {
            dispatch(
              ManageCourse({
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                  }
                },
              }),
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default Courses;
